import { graphql, Link } from 'gatsby';
import articleMapDataToComponents from '../components/article/articleMapDataToComponents';

import React from 'react';
import FeatureIntro from '../components/shared/featureIntro';
import HeadTags from '../components/global/headTags';
import videofeatureMapDataToComponents from './videofeatureMapDataToComponents'; //
import FeatureLayout from '../layouts/feature-layout';
import Button from '../components/ui/button';
import basicMapDataToComponents from './basicMapDataToComponents';
import * as style from './summitLanding.module.scss';
import useTemplateLifecycle from '../hooks/useTemplateLifecycle';
import resolveHeaderImage from '../utils/resolveHeaderImage';
import SponsorsGrid from '../components/shared/sponsorsGrid';

const SummitLanding = (props) => {
	const { data, location, transition } = props;
	const { startPage, isExiting, width } = useTemplateLifecycle({
		transitionStatus: transition?.status,
	});

	const {
		html_title_override,
		title,
		subheading,

		overview_text,
		sponsors,

		sponsors_additional_content,

		meta_description,
		meta_image,
		short_description,
		featured_image,

		featured_video,
		video,
		video_embed,
		paragraphs,

		featured_conferences,

		flex_content_one,
		flex_content_two,

		bottom_callouts,

		jsonId
	} = data.itemsJson ?? {};

	const { headerImage, headerTwitterImage } = resolveHeaderImage(meta_image, featured_image);

	let pageTitle = title;
	if(html_title_override) {
		pageTitle = html_title_override;
	}

	return (
		<FeatureLayout {...props} excludeParentFunctions>
			<div className="video-feature-content-wrapper conference-wrapper">
				<HeadTags
					title={pageTitle}
					description={subheading}
					image={headerImage}
					imageTwitter={headerTwitterImage}
					location={location}
				/>

				<FeatureIntro
					heading={title}
					description={subheading}
					backgroundImage={featured_image}
					conferenceMeta={{}}
				/>

				<div className={style.overviewTextWrap}>
					<div className={style.overviewText} dangerouslySetInnerHTML={{__html: overview_text}} />
				</div>

				<div className="featured-conferences">
					<div className="featured-conferences-inset">
						{featured_conferences && featured_conferences.length > 0 && featured_conferences.map(function(item, i) {
								return (
									<div
										className={`${style.featuredConference} featured-conference`}
									>
										{item.promo_image &&
											<Link to={item.path}>
												<img
													className={``}
													src={item?.promo_image?.sizes?.original ?? ''}
													alt={item?.promo_image?.alt_text ?? ''}
												/>
											</Link>
										}

										<h2 className='featured-conference-title'>
											{item.featured_title}
										</h2>

										<p className='featured-conference-location'>
											{item.featured_location}
										</p>

										<div className="featured-conference-link-wrap">
											<Button
												color="white"
												to={item.path}
												text={item.featured_link_text}
											/>
										</div>

												</div>
								);
						})}
					</div>
				</div>

				{flex_content_one && flex_content_one.length > 0 &&
					articleMapDataToComponents(flex_content_one, { reveal: true })
				}

				{/* SPONSORS */}
				<SponsorsGrid
					sponsors={sponsors}
					styles={style}
					additionalContent={sponsors_additional_content}
				/>
				{/* */}

				{bottom_callouts && bottom_callouts.length > 0 &&
					basicMapDataToComponents(bottom_callouts, { reveal: true })
				}
			</div>
		</FeatureLayout>
	);
};

// ...queryParagraphFields
// ...queryFlexContentOneFields
// ...queryFlexContentTwoFields

export default SummitLanding;

// eslint-disable-next-line
export const SummitLandingPageQuery = graphql`
query summitLandingPageContentByPath(
	$path: String!
	$menuId: String!
	$blog: String!
	$translations: String!
  ) {
	itemsJson(path: { eq: $path }) {
		  path
		  jsonId

		  meta_description
		  meta_image {
			sizes {
			  hero_md
			  hero_sm
			}
		  }

		  html_title_override

		  short_description

		  title
		  subheading

		  overview_text

		  featured_conferences {
		    title
			featured_title
			featured_link_text
			featured_location
			path
			featured_image {
			  sizes {
			    original
			  }
			}
			promo_image {
			  sizes {
			    original
			  }
			}
		  }

		  sponsors {
		    name
			logo_image {
			  sizes {
			    original
			  }
			}
			sponsor_url {
			  uri
			}
		  }

		  sponsors_additional_content

		  related_challenge {
			id
			title
			path
		  }

		  featured_image {
			image {
			  sizes {
				hero_lg
				hero_md
				hero_sm
				original
			  }
			}
		  }

		bottom_callouts {
			type
			items {
				title
				content_type
				path
				cta_link {
					url
					title
				}
				callout_subtitle
				image {
					sizes {
						wide_lg
						wide_md
						square_md
						original
					}

					dimensions {
						original {
							width
							height
						}
					}
					caption
					credit
					credit_plain
					alt_text
					title
				}
			}
		}

		...queryFlexContentOneFields
	}
	social: allItemsJson(filter: { id: { eq: $menuId } }) {
	  edges {
		node {
		  menu_social {
			title
			menu_name
			weight
			url
			class
			target
		  }
		}
	  }
	}

	# Index Content Data
	...headerFields
	...footerFields
	...SharedBlogFields
	...SharedTranslationsFields
	...MegaMenuFields
  }

`;
